import { Tooltip, TooltipInteractionEnum } from 'sonata-react-components';

import type { ComponentProps, ReactElement, ReactNode } from 'react';

type Props = {
  /** A DOM element (e.g. a `span`): the tooltip attaches its ref and hover listeners to it. */
  children: ReactElement;
  /** Tooltip text. The children are rendered alone when empty. */
  content: ReactNode;
  placement?: ComponentProps<typeof Tooltip>['config']['placement'];
};

/** Design system tooltip shown on hover, in place of the browser's `title` attribute. */
export function HoverTooltip({ children, content, placement = 'top' }: Readonly<Props>) {
  if (!content) {
    return children;
  }

  return (
    <Tooltip
      config={{
        component: <span>{content}</span>,
        interactions: [TooltipInteractionEnum.hover],
        placement,
        portal: true,
        strategy: 'fixed'
      }}
    >
      {children}
    </Tooltip>
  );
}
